module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar-week-fill-8ff0cb0a.svg";